import clsx from 'clsx';

export interface DerivativeBreadcrumbProps {
  /** Current input name (the derivative). */
  child: string;
  /** Source name + provenance label, e.g. "FRED InterestRate". */
  parentSource: string;
  className?: string;
}

/**
 * Inline `[child] ← [parent source]` breadcrumb rendered beneath
 * `<VariableRow>` when `record.derivedFrom` is set. Phase 3 Session 4.
 *
 * Visual: small, dim, mono. Communicates the lineage so the user
 * understands why two inputs move together (e.g. SeniorInterestRate
 * shifts when market InterestRate updates).
 */
export function DerivativeBreadcrumb({
  child,
  parentSource,
  className,
}: DerivativeBreadcrumbProps) {
  return (
    <div
      data-testid="derivative-breadcrumb"
      data-child={child}
      data-parent-source={parentSource}
      className={clsx(
        'text-micro font-mono text-text-dim flex items-center gap-1',
        className,
      )}
    >
      <span className="text-text-muted">{child}</span>
      <span aria-hidden="true">←</span>
      <span>{parentSource}</span>
    </div>
  );
}
